import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Box, Typography, Grid, Button, Skeleton } from "@mui/material";
import { Elevator, Build, Security } from "@mui/icons-material";
import axiosInstance from "../../../../utils/axiosConfig";

const iconMap = {
  Elevator: Elevator,
  Build: Build,
  Security: Security,
};

function Interest() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [landingOptions, setLandingOptions] = useState();
  const navigate = useNavigate();

  useEffect(() => {
    fetchServiceOfferings();
    fetchLandingOptions();
  }, []);

  const fetchServiceOfferings = async () => {
    try {
      const response = await axiosInstance.get(
        `/service_offerings?offering_type=interest`
      );
      setItems(response.data);
    } catch (error) {
      console.error("Error fetching service offerings:", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchLandingOptions = async () => {
    try {
      const response = await axiosInstance.get("/landing_options");
      setLandingOptions(response.data);
    } catch (error) {
      console.error("Error fetching landing options:", error);
    }
  };

  const handleViewMore = (serviceId) => {
    navigate(`/services/${serviceId}`);
  };

  const renderIcon = (iconName) => {
    const IconComponent = iconMap[iconName];
    return IconComponent ? (
      <IconComponent sx={{ fontSize: 40, color: "#FFD700" }} />
    ) : null;
  };

  const interestText = landingOptions?.filter((x) => x.key === "interest_text");

  const renderSkeletons = () => (
    <>
      {[1, 2, 3].map((item) => (
        <Grid item xs={12} sm={6} md={4} key={item}>
          <Box
            sx={{
              border: "1px solid #e0e0e0",
              borderRadius: "8px",
              p: 3,
              textAlign: "center",
              height: "300px",
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
            }}
          >
            <Box>
              <Skeleton
                variant="circular"
                width={40}
                height={40}
                sx={{ margin: "0 auto" }}
              />
              <Skeleton variant="text" sx={{ mt: 2, height: 64 }} />
              <Skeleton variant="text" sx={{ mt: 1, mb: 2, height: 48 }} />
            </Box>
            <Skeleton
              variant="rectangular"
              width={120}
              height={36}
              sx={{ margin: "0 auto", borderRadius: "4px" }}
            />
          </Box>
        </Grid>
      ))}
    </>
  );

  return (
    <Box sx={{ py: 5, px: 3 }}>
      <Typography variant="h4" sx={{ textAlign: "center", mb: 3 }}>
        {interestText?.at(0)?.value}
      </Typography>
      <Grid container spacing={3}>
        {loading
          ? renderSkeletons()
          : items.map((item) => (
              <Grid item xs={12} sm={6} md={4} key={item.id}>
                <Box
                  sx={{
                    border: "1px solid #e0e0e0",
                    borderRadius: "8px",
                    p: 3,
                    textAlign: "center",
                    height: "300px",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                    transition: "transform 0.3s",
                    ":hover": {
                      transform: "scale(1.05)",
                    },
                  }}
                >
                  <Box>
                    {renderIcon(item.icon_name)}
                    <Typography
                      variant="h6"
                      sx={{ mt: 2, fontWeight: "bold", minHeight: "64px" }}
                    >
                      {item.title}
                    </Typography>
                    <Typography
                      variant="body2"
                      sx={{ mt: 1, mb: 2, minHeight: "48px" }}
                    >
                      {item.description}
                    </Typography>
                  </Box>
                  <Button
                    variant="contained"
                    onClick={() => handleViewMore(item.id)}
                    sx={{
                      backgroundColor: "#29474d",
                      color: "#FFFFFF",
                      fontWeight: "bold",
                      padding: "6px 16px",
                      width: "120px",
                      margin: "0 auto",
                      ":hover": {
                        backgroundColor: "#3a5c63",
                        transform: "translateY(-2px)",
                        boxShadow: "0 4px 8px rgba(0,0,0,0.2)",
                      },
                    }}
                  >
                    {item.button_text}
                  </Button>
                </Box>
              </Grid>
            ))}
      </Grid>
    </Box>
  );
}

export default Interest;
